import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { View } from 'react-native';
import { getTestId } from '../../utils';
export var InView = props => {
  var children = props.children,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InView' : _props$testID,
    _props$triggerOnce = props.triggerOnce,
    triggerOnce = _props$triggerOnce === void 0 ? false : _props$triggerOnce,
    onChange = props.onChange;
  var containerRef = useRef(null);
  var unobserveHandler = observer => {
    if (containerRef.current) observer.unobserve(containerRef.current);
  };
  useEffect(() => {
    var observer = new IntersectionObserver(entries => {
      var entry = entries[0];
      var inView = entry.isIntersecting;
      onChange === null || onChange === void 0 ? void 0 : onChange(inView);
      if (inView && triggerOnce) unobserveHandler(observer);
    }, {
      threshold: 0.1
    });
    if (containerRef.current) observer.observe(containerRef.current);
    return () => {
      unobserveHandler(observer);
    };
  }, [containerRef.current]);
  return _jsx(View, Object.assign({
    ref: containerRef,
    style: style
  }, getTestId(testID), {
    children: children
  }));
};